<template>
  <div
    id="landing-page"
    v-if="surveyDetails && !surveyDetails.expired && surveyDesign"
    :style="`background-color : ${surveyDesign.backgroundColor}`"
  >
    <b-container>
      <b-row>
        <b-col lg="10" class="mx-auto text-center">
          <b-img
            :src="
              surveyDesign.logo
                ? surveyDesign.logo
                : require('@/assets/images/rush-logo.png')
            "
            fluid
            alt="Survey Logo"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          lg="10"
          id="survey-title"
          :style="`color: ${surveyDesign.titleColor}; font-size: ${
            surveyDesign.titleFontSize
          }; text-align: ${surveyDesign.titleTextAlign}; font-weight: ${
            surveyDesign.isTitleBold ? 'bold' : 'normal'
          }; text-decoration: ${
            surveyDesign.isTitleUnderline ? 'underline' : 'none'
          }; font-style: ${surveyDesign.isTitleItalic ? 'italic' : 'normal'};`"
        >
          {{ surveyDetails.title }}
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="10" class="mx-auto text-center">
          <b-img
            :src="
              surveyDesign.banner
                ? surveyDesign.banner
                : require('@/assets/images/rush-banner.png')
            "
            fluid
            alt="Survey Banner"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          lg="10"
          id="survey-description"
          :style="`color: ${surveyDesign.descriptionColor}; font-size: ${
            surveyDesign.descriptionFontSize
          }; text-align: ${surveyDesign.descriptionTextAlign}; font-weight: ${
            surveyDesign.isDescriptionBold ? 'bold' : 'normal'
          }; text-decoration: ${
            surveyDesign.isDescriptionUnderline ? 'underline' : 'none'
          }; font-style: ${
            surveyDesign.isDescriptionItalic ? 'italic' : 'normal'
          };`"
        >
          {{ surveyDetails.description }}
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="10" class="mx-auto text-md-right">
          <b-button
            pill
            class="col-md-3 py-2"
            :style="`
              background-color: ${surveyDesign.themeColor};
              border-color: ${surveyDesign.themeColor};
              color: ${surveyDesign.buttonTextColor};
            `"
            :to="{
              name:
                !!surveyDetails.is_login_required && !this.authToken
                  ? 'SignUp'
                  : 'Question',
            }"
          >
            Next
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Landing",
  computed: {
    ...mapGetters("survey", ["surveyDetails", "surveyDesign"]),
    ...mapGetters("auth", ["authToken"]),
  },
};
</script>

<style>
</style>